export const blurEffectProps = {
  border: 0,
  backgroundColor: 'rgba(255,255,255,0.1)',
  backdropFilter: 'blur(10px)',
  // boxShadow: 3,
};
